import { pathToRegexp, match as pathMatch } from 'path-to-regexp';
import snakeize from 'snakeize';

import routes from 'app/pages/routes';

import { getMarketItemTypes } from './constants';
import { getParams } from './url';

const MARKET_ITEM_TYPES = getMarketItemTypes();

const getScreenName = (pathname, params) => {
  const routeInfo = routes.find((route) => {
    const r = pathToRegexp(route.path);
    const match = r.exec(pathname);
    if (!match) {
      return false;
    }

    if (match[0] !== pathname) {
      return false;
    }

    return true;
  });

  if (!routeInfo) {
    return [null, {}];
  }

  const urlMatch = pathMatch(routeInfo.path);
  const { params: extraParams } = urlMatch(pathname);
  let screenName;

  switch (routeInfo.path) {
    // 보관함
    case '/library':
      if (params.menu === 'like') {
        screenName = `${routeInfo.screenName}/좋아요`;
      } else if (params.menu === 'following') {
        screenName = `${routeInfo.screenName}/팔로잉`;
      } else {
        screenName = `${routeInfo.screenName}/읽은작품`;
      }
      break;
    // 응원 목록
    case '/stories/:storyId(\\d+)/cheers':
      if (params.menu === 'cheer') {
        screenName = `${routeInfo.screenName}/최근 응원 목록`;
      } else {
        screenName = `${routeInfo.screenName}/응원 랭킹`;
      }
      break;
    // 유저 상세
    case '/users/:userId(\\d+)':
      if (params.menu === 'communityPosts') {
        screenName = `${routeInfo.screenName}/커뮤니티`;
      } else {
        screenName = `${routeInfo.screenName}`;
      }
      break;
    // 검색 결과
    case '/search-result':
      if (params.menu === 'user') {
        screenName = `${routeInfo.screenName}/작가`;
      } else if (params.menu === 'tag') {
        screenName = `${routeInfo.screenName}/태그`;
      } else {
        screenName = `${routeInfo.screenName}/작품`;
      }
      break;
    // 회차 상세
    // case '/stories/:storyId(\\d+)/episodes/:episodeId(\\d+)':
    //   if (params.more === 'true') {
    //     screenName = `${routeInfo.screenName}/종료 팝업`;
    //   }
    //   screenName = routeInfo.screenName;

    // 태그
    case '/search/tags/:tagId(\\d+)':
    case '/tags/:tagId(\\d+)':
      if (params.menu === 'newest') {
        screenName = `${routeInfo.screenName}/최신 작품`;
      } else {
        screenName = `${routeInfo.screenName}/인기 작품`;
      }
      break;
    // 채티마켓
    case '/market':
      {
        const marketMenus = Object.keys(MARKET_ITEM_TYPES).reduce(
          (acc, key) => {
            return {
              ...acc,
              [MARKET_ITEM_TYPES[key].type]: MARKET_ITEM_TYPES[key].label,
            };
          },
          { curation: null }
        );
        const menuName = marketMenus[params.menu];
        if (menuName) {
          screenName = `${routeInfo.screenName}/${menuName}`;
        } else {
          screenName = `${routeInfo.screenName}`;
        }
      }
      break;
    default:
      screenName = routeInfo.screenName;
  }

  return [screenName, extraParams];
};

const logScreen = (pathname, search) => {
  if (!__CLIENT__) {
    return;
  }

  const params = getParams(search);
  const [screenName, parameters] = getScreenName(pathname, params);

  if (!screenName) {
    return;
  }

  window.ci.web.data('screen', {
    screenName,
    parameters: JSON.stringify(snakeize(parameters)),
  });
};

export default {
  getScreenName,
  logScreen,
};



// WEBPACK FOOTER //
// ./src/app/utils/screen.js